import { createApp } from 'vue';
import TarToIsoConverter from '@/Components/TarToIsoConverter.vue';
import '@styles/app.css';

createApp(TarToIsoConverter).mount('#tar-to-iso-converter');
